export default __webpack_public_path__ + "static/media/meridio_xrisis_pezis_metakinisis_big.6e802fa7.svg";